const hasPostscriptExtension = file => /\.(eps|ai)$/i.test(file.name);
export default hasPostscriptExtension;